module.exports = __webpack_public_path__ + "static/media/ico-locked.92a02523.svg";